<template>
  <div v-if="destination" class="itinerary-container">
    <button
      type="button"
      class="button-itinerary"
      title="Lancer l'itinéraire"
      @click.prevent="openItinerary"
    >
      <i class="fas fa-route" aria-hidden="true" />
    </button>
  </div>
</template>

<script>
import { GeoJSON } from "ol/format";
import { getCenter } from "ol/extent";

import mapService from "@/services/map-service";

function latLonFromGeoJSON(geometry) {
  if (!geometry) return null;
  const feature = new GeoJSON().readFeature({
    type: "Feature",
    geometry,
    properties: {},
  });
  const geom = feature.getGeometry();
  if (!geom) return null;
  const [lon, lat] = getCenter(geom.getExtent());
  if (!Number.isFinite(lat) || !Number.isFinite(lon)) return null;
  return { lat, lon };
}

export default {
  name: "ItineraryButton",

  props: {
    feature: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      mapTarget: null,
    };
  },

  computed: {
    destination() {
      if (this.feature?.geometry) {
        return latLonFromGeoJSON(this.feature.geometry);
      }
      return this.mapTarget;
    },
  },

  mounted() {
    this.onTarget = (event) => {
      this.mapTarget = event.detail;
    };
    document.addEventListener("itinerary-target", this.onTarget);
    if (!this.feature) {
      this.mapTarget = mapService.itineraryTarget || null;
    }
  },

  beforeDestroy() {
    document.removeEventListener("itinerary-target", this.onTarget);
  },

  methods: {
    openItinerary() {
      const { lat, lon } = this.destination;
      const isMobile =
        /Android|iPhone|iPad|iPod/i.test(navigator.userAgent) ||
        window.matchMedia("(pointer: coarse)").matches;
      if (isMobile) {
        document.location.href = `google.navigation://?q=${lat},${lon}`;
        return;
      }
      window.open(
        `https://www.google.com/maps/dir/?api=1&destination=${lat},${lon}`,
        "_blank",
        "noopener",
      );
    },
  },
};
</script>
